<div class="upgrade-banner-wrapper">
  <i class="xos-icon icon-upgrade-stars"></i>
  <div class="title">Upgrade to unlock more power!</div>
  <div class="message">This workspace is currently has limited features. Click to request access.</div>
  <a href="mailto:sales@xostrucks.com">Contact sales</a>
</div>
